import { Button, ClickAwayListener, MenuItem, MenuList, Popper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useRef, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';

const useStyles = makeStyles(() => ({
  button: (props) => ({
    // border: '1px solid #54c6e8',
    backgroundColor: props.backgroundColor !== undefined ? props.backgroundColor : '#54c6e8',
    color: '#fff',
    width: props.width !== undefined ? props.width : 90,
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    textTransform: 'initial',
    '&:hover': {
      background: props.backgroundHover !== undefined ? props.backgroundHover : '#1093b9',
    },
  }),
  menuList: {
    backgroundColor: '#eee',
    borderRadius: 5,
    minWidth: 180,
    marginTop: 5,
    boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
  },
  menuItem: {
    backgroundColor: '#eee',
    color: '#000',
    textTransform: 'initial',
    '&:hover': {
      background: '#bfbfbf',
    },
  },
}));

const GroupButton = ({ actions = [], label = '', colors, position = 'end', disabled }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const styles = useStyles(colors);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <>
      <Button onClick={handleToggle} className={styles.button} ref={anchorRef} disabled={disabled}>
        <Typography>{label}</Typography>
        <FaChevronDown style={{ marginLeft: '5px', marginTop: '2px' }} />
      </Button>

      <Popper open={open} anchorEl={anchorRef.current} transition disablePortal placement={`bottom-${position}`}>
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList className={styles.menuList}>
            {actions.map((option, index) => (
              <MenuItem key={index} onClick={option.onClick} className={styles.menuItem}>
                <Typography>{option.label}</Typography>
              </MenuItem>
            ))}
          </MenuList>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default GroupButton;
